import ManagementCompany from './ManagementCompany'

export default ManagementCompany;